import { useContext } from "react";
import { SharedContactContext } from "./SharedContactContext";

const useSharedContact = () => useContext(SharedContactContext);

export default useSharedContact;
